import React, { useEffect, useState } from 'react';
import { Button } from '../../subkit-ui';
import { TWInput } from '../TWInput';
import { validateEmail } from '../../utils/helpers';
import { serviceLeadCreated } from '../../utils/segmentAnalytics';
import { generateReferralLink } from '../../utils/referralProgram';
import LinkCopyBox from '../TWLinkCopyBox';
import ReferralProgramCopy from './ReferralProgramCopy';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var TWReferralLink = function TWReferralLink(_ref) {
  var currentUser = _ref.currentUser,
      providerService = _ref.providerService,
      createServiceProspect = _ref.createServiceProspect,
      providerSlug = _ref.providerSlug,
      activeReferralProgram = _ref.activeReferralProgram;

  var _useState = useState(''),
      email = _useState[0],
      setEmail = _useState[1];

  var _useState2 = useState(false),
      isValid = _useState2[0],
      setValid = _useState2[1];

  useEffect(function () {
    if (!email) {
      setValid(false);
      return;
    }

    setValid(validateEmail(email));
  }, [email]);

  var onSubmit = function onSubmit(e) {
    e.preventDefault();
    createServiceProspect({
      email: email,
      serviceId: providerService.id
    }).then(function (prospect) {
      return prospect && serviceLeadCreated({
        providerService: providerService,
        currentUser: currentUser
      });
    });
  };

  var link;
  if (currentUser !== null && currentUser !== void 0 && currentUser.shareCode) link = generateReferralLink(providerSlug, currentUser.shareCode);
  return /*#__PURE__*/_jsxs("div", {
    className: "flex rounded-lg border border-yellow-500 bg-yellow-50",
    children: [/*#__PURE__*/_jsx("div", {
      className: "ml-12 mb-6 mt-9 hidden lg:block",
      children: /*#__PURE__*/_jsx("img", {
        src: "/images/referral_link_1.png",
        alt: "squiggle"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex-1 px-4 md:px-12 py-8 md:py-8",
      children: [!!link && /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(ReferralProgramCopy, {
          activeReferralProgram: activeReferralProgram
        }), /*#__PURE__*/_jsx("div", {
          className: "fw-500 pt-2",
          children: "Your unique referral link:"
        }), /*#__PURE__*/_jsx("div", {
          className: "pt-1",
          children: /*#__PURE__*/_jsx(LinkCopyBox, {
            link: link
          })
        })]
      }), !link && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ReferralProgramCopy, {
          activeReferralProgram: activeReferralProgram
        }), /*#__PURE__*/_jsx("form", {
          onSubmit: onSubmit,
          children: /*#__PURE__*/_jsxs("div", {
            className: "md:flex md:items-end",
            children: [/*#__PURE__*/_jsx("div", {
              className: "md:flex-1",
              children: /*#__PURE__*/_jsx(TWInput, {
                label: "Email Address",
                placeholder: "yourname@email.com",
                type: "email",
                onChange: function onChange(e) {
                  return setEmail(e.target.value);
                }
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "mt-4 md:mt-0 md:ml-4 md:mb-1",
              children: /*#__PURE__*/_jsx(Button, {
                text: "Get My Link",
                type: "secondary",
                disabled: !isValid
              })
            })]
          })
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "mr-14 my-5 hidden md:block",
      children: /*#__PURE__*/_jsx("img", {
        src: "/images/referral_link_2.png",
        alt: "squiggle"
      })
    })]
  });
};

export default TWReferralLink;